import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
//var CanvasJSReact = require('@canvasjs/react-charts');
 import HISTORY from './../history.json'
 
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
 
class Graph extends Component {
	render() {
		// console.log('calling props data',this.props.data)
		// console.log("Graph component called")
		
		const options = {
			animationEnabled: true,
			exportEnabled: true,
			theme: "light1", // "light2", "dark1", "dark2"
			title:{
				text: "Deal Count v/s Tools"
			},
			axisY: {
				title: "Deal Count",
				suffix: ""
			},
			axisX: {
				title: "Tool Name",
				prefix: "",
				interval: 4,
				maximum: Object.keys(HISTORY).length
			},
			data: [{
				type: "line",
				dataPoints: this.props.data
			}]
		}
		return (
		<div>
			<CanvasJSChart options = {options} style={{width:"100%"}}
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
	}
}
export default Graph